module.exports = __webpack_public_path__ + "img/search_dark.92dd9cb7.svg";